import { Injectable } from '@angular/core';

import { fetchAuthSession } from '@aws-amplify/auth';

export interface UserAuth {
  getAccessToken(): Promise<string | null>;
}

@Injectable({
  providedIn: 'root',
})
export class UserAuthService implements UserAuth {
  async getAccessToken(): Promise<string | null> {
    try {
      const session = await fetchAuthSession();
      const accessToken = session.tokens?.accessToken?.toString() ?? null;
      return accessToken;
    } catch (error) {
      console.error('Error fetching Access token:', error);
      return null;
    }
  }
}
